/* this file is transformed by vux-loader */
/* eslint-disable */
import _objectSpread from "/Users/pajk01/workspace/n34220_autoconfig_STATIC/vue-scrm_temp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.every.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
import { mapState } from 'vuex';
export default {
  name: 'RTF',
  props: {
    content: String
  },
  data: function data() {
    return {
      imgsIsLoaded: []
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    rtfContent: function rtfContent(state) {
      return state.mall.rtfContent;
    }
  })), {}, {
    html: function html() {
      return this.content || this.rtfContent || '';
    }
  }),
  watch: {
    imgsIsLoaded: function imgsIsLoaded() {
      var isAllLoaded = this.imgsIsLoaded.every(function (x) {
        return x === true;
      });

      if (isAllLoaded) {
        this.$emit('imgs-all-loaded');
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      var that = _this;

      var imgs = _this.$refs.html.querySelectorAll('img');

      _this.imgsIsLoaded = Array.from(imgs).map(function (x) {
        return false;
      });
      console.log(imgs);

      if (imgs.length > 0) {
        imgs.forEach(function (img, index) {
          var handler = function handler(e) {
            that.$set(that.imgsIsLoaded, index, true);
          };

          img.removeEventListener('load', handler);
          img.addEventListener('load', handler); // img.onload
        });
      }
    });
  }
};